import _styled from "styled-components";
import type { SanityPageBuilderAccordionListSection, SanityPageBuilderSection } from "@ouster/shared";
import { AccordionListBlockView } from "~/features/blocks/inventory/accordion-list";
import { AccordionListItemView } from "~/features/blocks/inventory/accordion-list/accordion-list-item";
import { AccordionListItemBulletPointView } from "~/features/blocks/inventory/accordion-list/accordion-list-item-bullet-point";
import { hasItems, takeFirst } from "~/features/app/utils";
import { type Mode } from "~/features/ui/get-theme-style";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderAccordionListSection;
  };
};
export function SanityAccordionListSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  return <AccordionListBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemValue={item => item._key ?? ""} hasTopDivider={sectionSettings?.hasTopDivider ?? true} items={sectionContent.items} mode={mode} renderItem={(item, isOpen, count) => {
    const hasMedia = hasRenderableSanityMedia(item.media);
    return <AccordionListItemView bulletPoints={hasItems(item.bulletPoints) ? <_StyledDiv $_css={[{
      "position": "relative",
      "zIndex": "10",
      "display": "flex",
      "flexDirection": "column",
      "rowGap": "var(--spacing-lg)",
      "borderTopWidth": "1px",
      "borderColor": "var(--stroke-primary)",
      "padding": "var(--spacing-lg)",
      "@media (min-width: 1024px)": {
        "padding": "var(--spacing-xl)"
      }
    }]}>
                  {item.bulletPoints.map(bulletPoint => <AccordionListItemBulletPointView key={bulletPoint._key} text={bulletPoint.text?.length ? <SanityRichText value={bulletPoint.text} /> : undefined} title={bulletPoint.title} />)}
                </_StyledDiv> : undefined} count={count} hasMedia={hasMedia} isOpen={isOpen} link={takeFirst(toCraftLinkArray(item.link))} mediaDesktop={hasMedia ? <SanityMediaFigure fit="cover" media={item.media} sizes="lg:50vw" /> : undefined} mediaMobile={hasMedia ? <SanityMediaFigure media={item.media} ratio="3/2" sizes="lg:50vw" /> : undefined} mode={mode} shortDescription={item.shortDescription} text={item.text?.length ? <SanityRichText value={item.text} /> : undefined} theme={sectionSettings?.theme || "white"} title={item.title} value={item._key ?? ""} />;
  }} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "accordion-list___StyledDiv",
  componentId: "sc-1x9nvho-0"
})(["", ""], p => p.$_css);